export const SET_FORCE_DISCONNECT = 'SOCKET_SET_FORCE_DISCONNECT'
export const SET_CONNECTED = 'SOCKET_SET_CONNECTED'
